module.exports = __webpack_public_path__ + "static/tokr-webLa-25ad2c2d0c54ff6cecdb9a28ea6e57ea.jpg";